import React, { useCallback, useState } from "react";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";
import moment from "moment";

const SearchBar = (props) => {
  // SerachBar 기본 필드

  const {
    store: { userInfo },
  } = useAppContext();

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;
    //console.log("name === " + name + " || value === " + value);

    props.setSearchParameters({ ...props.searchParameters, [name]: value });
  });

  return (
    <>
      <div className="searchdata">
        <ul>
          <li className="date">
            <div className="divide40">
              <font color="grey">⦁</font> 입고일자
            </div>
            <div className="flex50">
              <input
                type="date"
                name="schSwghtDt"
                id="schSwghtDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.searchParameters.schSwghtDt}
              />
              &nbsp;~&nbsp;
              <input
                type="date"
                name="schEwghtDt"
                id="schEwghtDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.searchParameters.schEwghtDt}
              />
            </div>
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 사업장구분
            </div>
            <SelectBox
              mastCd="PLANT_CD"
              id="schPlantCd"
              name="schPlantCd"
              attr5="Y"
              topSelected="전체"
              onChange={handleChangeField}
              value={props.searchParameters.schPlantCd}
              className="datainput"
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
